import React, { useState, useEffect } from 'react';
import $ from 'jquery';
import Map from './Map.js';
import moment from 'moment';
import config from '../JSON/regions.json';

const MapComponent = ({ dates, satellites, region }) => {
    const [images, setImages] = useState(null);

    // console.log("MapComponent: " + dates);

    useEffect(() => {

        if (dates) {
            if (!config[region]["merged"] && (!satellites || !satellites.some(Boolean))) {
                setImages(null);
                return;
            }
            /* Pull images from image directory */
            const getImages = async () => {
                const dateArray = getDates(dates[0], dates[1]);

                const results = [];
                var extensions;

                // console.log(dates[0])
                // console.log(dates[1])


                if (config[region]["merged"]) {
                    extensions = ["msfr"];
                } else {
                    extensions = Object.keys(config["satellites"]);
                }
                //console.log("extensions", extensions);

                // console.log("extensions: " + extensions)
                // console.log("satellites: " + satellites)
                //filter extensions to only those selected
                if (satellites != null) {
                    extensions.splice(0, extensions.length, ...extensions.filter((_, i) => satellites[i]));

                }
                //console.log(extensions)


                for (var day of dateArray) {
                    //console.log("day", day);

                    const [y, m, d] = day;
                    const ym = `${y}${m}`;
                    const ymd = `${y}${m}${d}`;

                    for (const sat of extensions) {
                        var baseURL;
                        if (extensions[0] === "msfr") {
                            baseURL = `https://sfr.umd.edu/image_gm/conus/msfr/${ym}/`;
                        } else {
                            baseURL = `https://sfr.umd.edu/image_gmj/${region}/${sat}/${ym}/`;
                        }
                        try {
                            const response = await fetch(baseURL);
                            const html = await response.text();
                            const matches = [...html.matchAll(new RegExp(`href="([^"]*${ymd}[^"]*\\.png)"`, "g"))]
                                .map(m => m[1]);
                            //console.log(`${sat} matches`, matches)

                            const dayResults = await Promise.all(matches.map(async (match) => {
                                const png = match;
                                const pngURL = baseURL + png;
                                const bdyURL = pngURL.replace(".png", ".bdy");

                                const timeMatch = png.match(/(?:_S)?(\d{8})_(\d{6})/);
                                const imgDateStr = timeMatch[1];
                                const imgTimeStr = timeMatch[2];
                                const imgMoment = moment(`${imgDateStr}${imgTimeStr}`, "YYYYMMDDHHmmss");

                                const startMoment = moment(dates[0]);
                                const endMoment = moment(dates[1]);

                                if (!imgMoment.isBetween(startMoment, endMoment, null, '[]')) {
                                    //console.log(`${imgDateStr}${imgTimeStr} is not in between ${startMoment} and ${endMoment}`);
                                    return null;
                                }


                                //Get bounding for msfr
                                if (extensions[0] === "msfr") {
                                    const box = {
                                        west: -130,
                                        east: -60,
                                        south: 20,
                                        north: 55
                                    };
                                    const polygon = [
                                        [box.west, box.south],
                                        [box.east, box.south],
                                        [box.east, box.north],
                                        [box.west, box.north],
                                        [box.west, box.south]
                                    ];
                                    return [pngURL, box, polygon];
                                }
                                //Get bounding for non-msfr
                                else {
                                    const bdyResponse = await fetch(bdyURL);
                                    const bdyText = await bdyResponse.text();
                                    const lines = bdyText.trim().split('\n');
                                    const firstLine = lines[0].trim().split(/\s+/);
                                    const count = parseInt(firstLine[0]);
                                    const west = parseFloat(firstLine[1]);
                                    const east = parseFloat(firstLine[2]);
                                    const south = parseFloat(firstLine[3]);
                                    const north = parseFloat(firstLine[4]);
                                    const box = {
                                        west: west,
                                        east: east,
                                        south: south,
                                        north: north
                                    };

                                    const polygon = lines.slice(1).map(line => {
                                        const [lon, lat] = line.trim().split(/\s+/).map(Number);
                                        return [lon, lat];
                                    });
                                    //close polygon
                                    polygon.push(polygon[0]);

                                    return [pngURL, { west, east, south, north }, polygon];
                                }

                            }));

                            results.push(...dayResults.filter(Boolean));
                        } catch (error) {
                            continue;
                        }
                    }
                }

                //SORTING OF IMAGE TIMESTAMPS




                if (results.length > 0) {
                    const imgRegex = extensions[0] === "msfr"
                        ? /[0-9]{8}_[0-9]{6}/
                        : /S[0-9]{8}_[0-9]{6}/;
                    results.sort((a, b) => {
                        const aTime = a[0].match(imgRegex)?.[0] ?? "";
                        const bTime = b[0].match(imgRegex)?.[0] ?? "";
                        return aTime.localeCompare(bTime);
                    });
                    console.log(results)
                    setImages(results);
                } else {
                    setImages(null);
                    console.log("No images found.");
                }

            };

            getImages();
        }
    }, [dates, satellites, region]);

    return (
        <div>
            <Map images={images} region={region} />
        </div>
    );
}

/* Takes a starting date and stopping date and returns all the dates between them as an array inclusive */
function getDates(startDate, stopDate) {
    var dateArray = [];
    var currentDate = moment(startDate);
    var stopDateMoment = moment(stopDate);
    while (currentDate <= stopDateMoment) {
        var formatDate = moment(currentDate).format('YYYYMMDD');
        dateArray.push([formatDate.substring(0, 4), formatDate.substring(4, 6), formatDate.substring(6, 8)]);
        currentDate = moment(currentDate).add(1, 'days');
    }
    return dateArray;
}

export default MapComponent;